import React from 'react';
import img404 from '../images/404/Untitled design.png';

const NotFound = () => {
    return (
        <div>
            <img className='w-full' src={img404} alt="" />
        </div>
    );
};

export default NotFound;